<template>
  <tr>
    <td class="sub-menu">
      <el-checkbox
        v-model="cp_check"
        class="el-checkbox-e"
        :indeterminate="cp_indeterminate"
      >
        {{ row.name }}
      </el-checkbox>
    </td>
    <td>
      <!--<el-checkbox-group-->
      <!--v-if="row.children"-->
      <!--v-model="checkedChildren"-->
      <!--@change="handleChecked">-->
      <!--<el-checkbox-->
      <!--v-for="(ck, i) in row.children"-->
      <!--class="el-checkbox-e"-->
      <!--:label="ck.label"-->
      <!--:key="i">{{ck.label}}</el-checkbox>-->
      <!--</el-checkbox-group>-->
      <el-checkbox
        v-for="(ck, i) in row.actions"
        :key="i"
        v-model="ck.checked"
        class="el-checkbox-e"
        @change="handleChecked"
      >
        {{ ck.name }}
      </el-checkbox>
    </td>
  </tr>
</template>

<script>
export default {
    name: 'MenuItemRow',
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
        };
    },
    computed: {
        cp_indeterminate () {
            return !this.cp_check && this.row.actions.some(itm => itm.checked);
        },
        cp_check: {
            get () {
                return this.row.actions.every(itm => itm.checked);
            },
            set (v) {
                (this.row.actions || []).forEach(itm => (itm.checked = v));
            },
        },
    },
    mounted () {
    },
    methods: {
        handleChecked () {
            this.row.checked = (this.row.actions || []).every(itm => itm.checked);
            this.row.indeterminate = (this.row.actions || []).some(itm => itm.checked) && !this.row.checked;
            // this.emitChecked();
        },
    },
};
</script>

<style scoped lang="scss">
  .menu-table {
    td {
      border: 1px solid #ebeef5 {
        right-color: transparent;
        bottom-color: transparent;
      };
      padding: 5px 15px;
      &:last-of-type {
        border-right-color: #ebeef5;
      }
    }
    tr:last-of-type td {
      border-bottom-color: #ebeef5;
    }
  }
  .sub-menu {
    width: 100px;
  }
  label.el-checkbox {
    float: left;
    margin-left: 0;
    margin-right: 30px;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: inherit;
    }
  }
</style>

<style lang="scss">
  .el-checkbox.el-checkbox-e {
    .el-checkbox__input + .el-checkbox__label {
      color: inherit;
    }
  }
</style>
